import {
	LOG_MODAL_OPEN,
	LOG_INFO
} from '../actions/types';

const initialState = {
	log_modal_open: false,
	log_info: {}
}

export default function logsReducer(state = initialState, action){
	switch(action.type){
		case LOG_MODAL_OPEN:
			return {
				...state,
				log_modal_open: action.payload
			}
		case LOG_INFO:
			return {
				...state,
				log_info: action.payload
			}
		default:
			return state;
	}
}
